import { filterCategories } from "@/components/CategoriesLayouts/filterCategories.js";
import { useStore } from "vuex";
import { useCategoriesStore } from "@/stores/categories/index.ts";
import { RouteLocation, RouteLocationAsRelativeGeneric } from "vue-router";
import { PartialCategory } from "@/types/category.ts";

export default function useCategoriesRedirect() {
  const store = useStore();
  const categoriesStore = useCategoriesStore();

  function categoriesRedirect(
    to: RouteLocation
  ): RouteLocationAsRelativeGeneric | undefined {
    const { categoryID } = to.params;
    let cats: PartialCategory[] | undefined;
    if (categoryID) {
      cats = store.getters["api/categories"](categoryID);
    } else {
      cats = categoriesStore.get()?.categories;
    }
    const items = filterCategories(cats ?? [], store);
    if (items.length === 1 && !store.getters.showCMS) {
      // if back button then redirect accordingly
      if (to.query.backButton) {
        // if /categories then go to home
        if (to.name === "Categories") {
          return {
            name: "Home",
            params: {
              styleid: store.getters.getStyleID,
            },
            query: { backButton: "true" },
          };
        }
        // if has a parent categoryID then go to SubCategories
        const parentCatID = store.getters.getStoreVar(
          to.name,
          "page",
          "nonCMS",
          "parentCategoryID"
        );
        if (parentCatID != null) {
          return {
            name: "SubCategories",
            params: {
              styleid: store.getters.getStyleID,
              categoryID: parentCatID,
            },
            query: { backButton: "true" },
          };
        }
        // otherwise take to /categories
        return {
          name: "Categories",
          params: {
            styleid: store.getters.getStyleID,
          },
          query: { backButton: "true" },
        };
      }
      // if hasSubCategories then go to /SubCategories otherwise take it to /Categories
      const { hasSubCategories } = items[0];
      if (hasSubCategories) {
        return {
          name: "SubCategories",
          params: {
            styleid: store.getters.getStyleID,
            categoryID: items[0].path.split("/")[2],
          },
        };
      }
      return {
        name: "Category",
        params: {
          styleid: store.getters.getStyleID,
          categoryID: items[0].path.split("/")[2],
        },
      };
    }
    return undefined;
  }

  return {
    categoriesRedirect,
  };
}
